export var SopTypes;
(function (SopTypes) {
    SopTypes["TEMPERATURE_RANGE"] = "TEMPERATURE_RANGE";
    SopTypes["HUMIDITY_RANGE"] = "HUMIDITY_RANGE";
    SopTypes["DOOR_OPENED_MAX_DURATION"] = "DOOR_OPENED_MAX_DURATION";
    SopTypes["SITE_OPERATING_HOURS"] = "SITE_OPERATING_HOURS";
    SopTypes["EQUIPMENT_OPERATING_HOURS"] = "EQUIPMENT_OPERATING_HOURS";
    SopTypes["NORMAL_POWER_CONSUMPTION"] = "NORMAL_POWER_CONSUMPTION";
    SopTypes["ENERGY_TARIFF"] = "ENERGY_TARIFF";
    SopTypes["LABOR_RATE"] = "LABOR_RATE";
    SopTypes["MAINTENANCE_VISIT_RATE"] = "MAINTENANCE_VISIT_RATE";
    SopTypes["PRODUCT_VALUE"] = "PRODUCT_VALUE";
    SopTypes["HVAC"] = "HVAC";
    SopTypes["TASK"] = "TASK";
})(SopTypes || (SopTypes = {}));
export var SopPolicyTypes;
(function (SopPolicyTypes) {
    SopPolicyTypes["DOOR_OPENED_MAX_DURATION"] = "DOOR_OPENED_MAX_DURATION";
    SopPolicyTypes["HUMIDITY_RANGE"] = "HUMIDITY_RANGE";
    SopPolicyTypes["NORMAL_POWER_CONSUMPTION"] = "NORMAL_POWER_CONSUMPTION";
    SopPolicyTypes["TEMPERATURE_RANGE"] = "TEMPERATURE_RANGE";
    SopPolicyTypes["SITE_OPERATING_HOURS"] = "SITE_OPERATING_HOURS";
    SopPolicyTypes["EQUIPMENT_OPERATING_HOURS"] = "EQUIPMENT_OPERATING_HOURS";
})(SopPolicyTypes || (SopPolicyTypes = {}));
export var SopCostTypes;
(function (SopCostTypes) {
    SopCostTypes["ENERGY_TARIFF"] = "ENERGY_TARIFF";
    SopCostTypes["LABOR_RATE"] = "LABOR_RATE";
    SopCostTypes["MAINTENANCE_VISIT_RATE"] = "MAINTENANCE_VISIT_RATE";
    SopCostTypes["PRODUCT_VALUE"] = "PRODUCT_VALUE";
})(SopCostTypes || (SopCostTypes = {}));
// org level operating hours SOP is not available at the moment
export var OrgSopTypes;
(function (OrgSopTypes) {
    OrgSopTypes["TEMPERATURE_RANGE"] = "TEMPERATURE_RANGE";
    OrgSopTypes["HUMIDITY_RANGE"] = "HUMIDITY_RANGE";
    OrgSopTypes["DOOR_OPENED_MAX_DURATION"] = "DOOR_OPENED_MAX_DURATION";
    OrgSopTypes["NORMAL_POWER_CONSUMPTION"] = "NORMAL_POWER_CONSUMPTION";
    OrgSopTypes["ENERGY_TARIFF"] = "ENERGY_TARIFF";
    OrgSopTypes["LABOR_RATE"] = "LABOR_RATE";
    OrgSopTypes["MAINTENANCE_VISIT_RATE"] = "MAINTENANCE_VISIT_RATE";
    OrgSopTypes["PRODUCT_VALUE"] = "PRODUCT_VALUE";
})(OrgSopTypes || (OrgSopTypes = {}));
export var SopTypeToLabel;
(function (SopTypeToLabel) {
    SopTypeToLabel["TEMPERATURE_RANGE"] = "Temperature Range";
    SopTypeToLabel["HUMIDITY_RANGE"] = "Humidity Range";
    SopTypeToLabel["DOOR_OPENED_MAX_DURATION"] = "Door Opening Duration";
    SopTypeToLabel["SITE_OPERATING_HOURS"] = "Occupied Hours (Site)";
    SopTypeToLabel["EQUIPMENT_OPERATING_HOURS"] = "Operating Hours (Equipment)";
    SopTypeToLabel["NORMAL_POWER_CONSUMPTION"] = "Normal Power Consumption";
    SopTypeToLabel["ENERGY_TARIFF"] = "Energy Tariff";
    SopTypeToLabel["LABOR_RATE"] = "Labor Rate";
    SopTypeToLabel["PRODUCT_VALUE"] = "Product Value";
    SopTypeToLabel["MAINTENANCE_VISIT_RATE"] = "Service/Maintenance Visit";
    SopTypeToLabel["HVAC"] = "HVAC";
    SopTypeToLabel["TASK"] = "TASK";
})(SopTypeToLabel || (SopTypeToLabel = {}));
export var SopTypeToShortLabel;
(function (SopTypeToShortLabel) {
    SopTypeToShortLabel["TEMPERATURE_RANGE"] = "Temp Range";
    SopTypeToShortLabel["HUMIDITY_RANGE"] = "Humidity Range";
    SopTypeToShortLabel["DOOR_OPENED_MAX_DURATION"] = "Door Open";
    SopTypeToShortLabel["SITE_OPERATING_HOURS"] = "Occupied Hours";
    SopTypeToShortLabel["EQUIPMENT_OPERATING_HOURS"] = "Operating Hours";
    SopTypeToShortLabel["NORMAL_POWER_CONSUMPTION"] = "Normal Power Consumption";
    SopTypeToShortLabel["ENERGY_TARIFF"] = "Energy Tariff";
    SopTypeToShortLabel["LABOR_RATE"] = "Labor Rate";
    SopTypeToShortLabel["PRODUCT_VALUE"] = "Product Value";
    SopTypeToShortLabel["MAINTENANCE_VISIT_RATE"] = "Maintenance Visit";
    SopTypeToShortLabel["HVAC"] = "HVAC";
    SopTypeToShortLabel["TASK"] = "TASK";
})(SopTypeToShortLabel || (SopTypeToShortLabel = {}));
